import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Plug, Calendar, Video, Mail, CreditCard, CheckCircle, XCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import SEO from '@/components/SEO';

const integrations = [
  {
    name: 'Stripe',
    description: 'Payment processing',
    icon: CreditCard,
    status: 'connected',
  },
  {
    name: 'Google Calendar',
    description: 'Appointment scheduling',
    icon: Calendar,
    status: 'connected',
  },
  {
    name: 'Zoom',
    description: 'Video consultations',
    icon: Video,
    status: 'connected',
  },
  {
    name: 'Resend',
    description: 'Email notifications',
    icon: Mail,
    status: 'connected',
  },
];

const AdminIntegrations = () => {
  return (
    <>
      <SEO 
        title="Integrations - Admin"
        description="Manage third-party integrations"
      />
      <div className="p-6 lg:p-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Integrations</h1>
          <p className="text-muted-foreground">
            Configure and test third-party service connections
          </p>
        </div>

        {/* Integration Cards */}
        <div className="grid gap-6 md:grid-cols-2">
          {integrations.map((integration) => {
            const Icon = integration.icon;
            const isConnected = integration.status === 'connected';
            
            return (
              <Card key={integration.name}>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="p-2 rounded-lg bg-primary/10">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <CardTitle className="text-lg">{integration.name}</CardTitle>
                        <CardDescription>{integration.description}</CardDescription>
                      </div>
                    </div>
                    <Badge variant={isConnected ? "default" : "secondary"} className="flex items-center gap-1">
                      {isConnected ? (
                        <>
                          <CheckCircle className="h-3 w-3" />
                          Connected
                        </>
                      ) : (
                        <>
                          <XCircle className="h-3 w-3" />
                          Disconnected
                        </>
                      )}
                    </Badge>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-6 text-center">
                    <p className="text-sm text-muted-foreground">
                      Configuration panel coming soon
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Info Card */}
        <Card className="mt-6">
          <CardHeader>
            <CardTitle>Integration Management</CardTitle>
            <CardDescription>
              Test and configure service connections
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-12 text-center">
              <Plug className="h-12 w-12 mx-auto text-muted-foreground/50 mb-4" />
              <h3 className="text-lg font-semibold text-muted-foreground mb-2">
                Coming Soon
              </h3>
              <p className="text-sm text-muted-foreground max-w-md mx-auto">
                This section will allow you to manage all integrations.
                Features include:
              </p>
              <ul className="text-sm text-muted-foreground mt-4 space-y-1">
                <li>• Test integration connections</li>
                <li>• Update API keys and credentials</li>
                <li>• View integration logs</li>
                <li>• Configure webhook endpoints</li>
                <li>• Troubleshoot connection issues</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default AdminIntegrations;
